/* unplugin-vue-components disabled */import script from "./menu.vue?vue&type=script&setup=true&lang=js"
export * from "./menu.vue?vue&type=script&setup=true&lang=js"

import "./menu.vue?vue&type=style&index=0&id=6e7bc378&scoped=true&lang=css"
import "./menu.vue?vue&type=style&index=1&id=6e7bc378&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e7bc378"]])

export default __exports__